<script setup lang="ts">
import { startRefreshingTokens } from "@api-client/auth/auth";
import { CircleUser, User } from "lucide-vue-next";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { authState } from "@/ui-plus/useAuth";
import {
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuPortal
} from "@/components/ui/dropdown-menu";
import { initiateRedirectUserSettings, logout } from "@/ui-plus/auth/auth.pkce.redirect";

import { Monitor, Moon, Sun } from "lucide-vue-next";
import { useColorMode } from "@vueuse/core";

const mode = useColorMode();

const IS_DEV = import.meta.env.DEV;

</script>
<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <Button variant="secondary"
                    size="icon"
                    class="rounded-full">
                <CircleUser class="h-5 w-5" />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
            <DropdownMenuLabel>
                <div
                     class="flex items-center p-4 space-x-4  rounded-lg border border-border/50 shadow-sm flex-col sm:flex-row">
                    <Avatar class="w-12 h-12 border-2"
                            :style="`background-image: url('https://avatar.vercel.sh/${authState.accessTokenPayload?.name}.jpg');background-size: cover;`">
                        <AvatarImage :src="authState.accessTokenPayload?.pictureUrl || ``" />
                        <AvatarFallback>
                            {{ authState.accessTokenPayload?.name?.slice(0, 4).toUpperCase() }}
                        </AvatarFallback>
                    </Avatar>
                    <div class="flex-1">
                        <p class="font-semibold text-foreground">{{ authState.accessTokenPayload?.name }}</p>
                        <p class="text-sm text-muted-foreground">{{ authState.accessTokenPayload?.email }}</p>
                    </div>
                </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />

            <DropdownMenuSub>
                <DropdownMenuSubTrigger>
                    <Moon v-if="mode === 'dark'"
                          class="mr-2 h-4 w-4" />
                    <Sun v-else-if="mode === 'light'"
                         class="mr-2 h-4 w-4" />
                    <span class="capitalize">{{ mode }}</span>
                </DropdownMenuSubTrigger>
                <DropdownMenuPortal>
                    <DropdownMenuSubContent>
                        <DropdownMenuItem @click="mode = 'light'">
                            <Sun />
                            Light
                        </DropdownMenuItem>
                        <DropdownMenuItem @click="mode = 'dark'">
                            <Moon />
                            Dark
                        </DropdownMenuItem>
                        <DropdownMenuItem @click="mode = 'auto'">
                            <Monitor />
                            System
                        </DropdownMenuItem>
                    </DropdownMenuSubContent>
                </DropdownMenuPortal>
            </DropdownMenuSub>

            <DropdownMenuSeparator />
            <DropdownMenuItem @click="initiateRedirectUserSettings">
                <User :stroke-width="3"
                      class="h-5 w-5" />MyOrderID account
            </DropdownMenuItem>
            <DropdownMenuItem @click="logout">
                Logout
            </DropdownMenuItem>
            <DropdownMenuItem v-if="IS_DEV"
                              @click="startRefreshingTokens()">
                DEV: Refresh Token
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>